import { Alert, AlertIcon, Flex, Spinner, Stack, Text } from '@chakra-ui/react';
import { startCase } from 'lodash';

import { useBrokerAccountRestrictions } from '@/cip/api/portfolio';

import { Portfolio } from '../../../_openapi/portfolio-optimizer';

/**
 * Broker-reported account restrictions (from the latest nav report) of the selected portfolios.
 * Renders nothing when no portfolio is selected or none of them is restricted.
 */
export const BrokerAccountRestrictions = ({ portfolios }: { portfolios: Portfolio[] }) => {
    const pIds = portfolios.map((portfolio) => portfolio.base.pId).filter(Boolean);
    const { data: restrictions, isPending, isFetching } = useBrokerAccountRestrictions(pIds);

    if (!pIds.length) return null;

    if (isPending) {
        return (
            <Flex alignItems="center" gap={2} color="gray.500">
                <Spinner size="sm" />
                <Text fontSize="sm">Checking broker account restrictions…</Text>
            </Flex>
        );
    }

    if (!restrictions?.length) return null;

    return (
        <Alert status="warning" borderRadius="md" alignItems="flex-start">
            <AlertIcon />
            <Stack gap={1}>
                <Flex alignItems="center" gap={2}>
                    <Text fontWeight="medium">
                        Broker account restrictions ({restrictions.length}) — as of {restrictions[0].tradeDate}
                    </Text>
                    {isFetching && <Spinner size="xs" />}
                </Flex>
                {restrictions.map((restriction) => (
                    <Text key={restriction.pId} fontSize="sm">
                        {restriction.pId} ({restriction.brokerId} {restriction.aC})
                        {restriction.restrictionCategory ? ` — ${startCase(restriction.restrictionCategory)}` : ''}:{' '}
                        {restriction.brokerRestrictions.join(', ')}
                    </Text>
                ))}
            </Stack>
        </Alert>
    );
};
